export default import.meta.ROLLDOWN_FILE_URL_$e1f8oulJwVfBHw_3aYc1w